/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const selectMeasures = (state: { measurePolicy: any; }) => state.measurePolicy.measures;
export const selectMeasureGroup = (state: { measurePolicy: any; }) => state.measurePolicy.measureGroup;
export const selectMeasuresFormData = (state: { measurePolicy: any; }) => state.measurePolicy.measureFormData;
export const selectMeasuresFormError = (state: { measurePolicy: any; }) => state.measurePolicy.measureFormError;